import * as React from 'react';
import { isEqual, pickBy, size } from 'lodash-es';
import cn from 'classnames';
import { Formik, useFormikContext } from 'formik';
import { useDebouncedCallback } from 'use-debounce';

import { FilterBar as FBar } from '../filter-bar';
import BadgeButton from '../search-result-page/BadgeButton';
import { Filters } from './Filters';
import { MAX } from './filters/RoomsFilter';
import { CSNAmenity, CSNAreaType } from '@weddingspot/ws-api-client';
import { FilterContext } from '../filter-bar/FilterContext';
import { useState } from 'react';

const _styles = require('./FilterBar.scss');

const filterTypes = ['Guest Rooms', 'Amenities', 'Areas', 'Radius', 'Filters'];

export type FormikValues = {
    rooms?: [number | null, number | null];
    amenities?: Record<CSNAmenity, boolean>;
    areas?: Record<CSNAreaType, boolean>;
    radius: number;
};

const Bar = () => {
    const context = useFormikContext<FormikValues>();
    const { values: formikValues } = context;

    const roomsCount =
        isEqual(formikValues.rooms, [0, MAX]) ||
        isEqual(formikValues.rooms, undefined) ||
        isEqual(formikValues.rooms, [0, null]) ||
        isEqual(formikValues.rooms, [null, null])
            ? 0
            : 1;
    const amenitiesCount = size(pickBy(formikValues.amenities));
    const areasCount = size(pickBy(formikValues.areas));

    const allFiltersTouched = roomsCount + (amenitiesCount ? 1 : 0) + (areasCount ? 1 : 0);

    const renderBadge = (key: string, badgeCount: number, visibleFor: 'mobile' | 'desktop', hideCount?: boolean) => {
        const { selectedFilter } = React.useContext(FilterContext);

        return (
            <span
                className={cn({
                    [_styles.visibleMobile]: visibleFor == 'mobile',
                    [_styles.visibleDesktop]: visibleFor == 'desktop',
                })}
            >
                <BadgeButton label={key} isActive={selectedFilter === key} badgeCount={badgeCount} badgeCountActiveOnly={hideCount} />
            </span>
        );
    };

    const renderFilters = () => {
        return <Filters />;
    };

    return (
        <FBar
            availableFilters={filterTypes}
            renderHeaderElement={(key: string) => {
                switch (key) {
                    case 'Guest Rooms':
                        return renderBadge(key, roomsCount, 'desktop', true);
                    case 'Radius':
                        return renderBadge(key, formikValues.radius, 'desktop', true);
                    case 'Amenities':
                        return renderBadge(key, amenitiesCount, 'desktop');
                    case 'Areas':
                        return renderBadge(key, areasCount, 'desktop');
                    case 'Filters':
                        return renderBadge(key, allFiltersTouched, 'mobile');
                    default:
                        return;
                }
            }}
            renderFilters={renderFilters}
        />
    );
};

interface Props {
    onFilterSubmit: (values: FormikValues) => void;
    roomsMin: number | null;
    roomsMax: number | null;
}

export const FilterBar = (props: Props) => {
    const [prevValues, setPrevValues] = useState({});
    const [onFormChange] = useDebouncedCallback((values: FormikValues) => {
        const _values = values;
        if (_values.rooms && _values.rooms[1] === MAX) {
            _values.rooms[1] = null;
        }
        if (!isEqual(values, prevValues)) {
            setPrevValues(values);
            props.onFilterSubmit(_values);
        }
    }, 300);

    return (
        <Formik
            initialValues={{
                rooms: [props.roomsMin, props.roomsMax],
                radius: 0,
            }}
            onSubmit={() => {}}
            validate={onFormChange}
        >
            <div className={_styles.wrapper}>
                <Bar />
            </div>
        </Formik>
    );
};
